<template>
  <ai-card v-bind="props" class="AiCardLearnMore">
    <template v-if="learnMoreUrl" #actions>
      <ai-button
        as-link
        :href="learnMoreUrl"
        target="_blank"
        variant="tertiary"
        :icon-right="'button-arrow-right' as IconName"
        :label="$t('hotel.card.buttonLabel')"
        :aria-label="$t('hotel.card.buttonLabel', { label: title })"
        slim
        small />
    </template>
  </ai-card>
</template>

<script setup lang="ts">
import type { IconName } from '../../atoms/AiIcon/types';

import AiCard from './AiCard.vue';

import type { AiPicture } from '~~/domains/graphql';

type Props = {
  title: string;
  description?: string;
  picture?: AiImageProps | AiPicture;
  label?: string;
  learnMoreUrl?: string;
};

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.AiCardLearnMore {
  height: 100%;
}
</style>
